export default __webpack_public_path__ + "static/media/Creator_Portal.7b94a80d.png";